export const translationEN = {
  error: {
    401: {
      title: 'Unauthorized',
      description: "You don't have authorization to view this page.",
      button: 'Back to homepage'
    },
    'slug-must-be-unique': 'The slug must be unique',
  },
  components: {
    menu: {
      logout: 'Logout',
    },
    footer: {
      policyprivacy: 'Policy privacy',
      aboutus: 'About Us',
      termsofservice: 'Terms of service',
    },
    table: {
      show: 'Show',
      notresults: 'Not results found',
    },
    navbar: {
      home: 'Home',
      users: 'Users',
      product_enrollments: 'Product enrollments',
      commison_enrollments: 'Courses Enrollments',
      products: 'Products',
      products_career: 'Career',
      products_course: 'Course',
      products_on_demand: 'On Demand',
      products_on_demand_b2b: 'On Demand B2B',
      productList: 'Products',
      subjects: 'Subjects',
      modules: 'Modules',
      courses: 'Courses',
      myCourses: 'My courses',
      students: 'Students',
      course: 'Course',
      courseConfig: 'Course settings',
      paths: 'Path',
      subjectVersions: 'Subject versions',
    },
    home: {
      welcome_title: 'Welcome to ',
      welcome_product_text: 'SMS',
      welcome_subtitle: 'Student Management System',
    },
    'state-icon': {
      create: 'C',
      open: 'O',
      close: 'C',
      opened: 'O',
      finaliced: 'F',
      closed: 'C',
      'create-tooltip': 'Created',
      'open-tooltip': 'Open',
      'close-tooltip': 'Close',
      'opened-tooltip': 'Opened',
      'finaliced-tooltip': 'Finalized',
      'closed-tooltip': 'Closed',
    },
  },
  attendance: {
    title: 'Attendance',
    'sub-title': 'Course',
    attendance: 'Attendance',
    registry: 'Attendance registration',
    'students-not-found': 'Student list not found',
    'state-present': 'Present',
    'state-late': 'Late',
    'state-no-registry': 'initial State',
    justify: 'justified',
    'state-justify': 'Justified',
    'get-attendance': 'Take attendance',
    'state-absent': 'Absent',
  },
  resources: {
    progressDisplay: {
      title: 'Progress Display',
      select: 'Select a progress display',
      percent: 'Percentage',
      stage: 'Stage',
      percent_with_final_stage: 'Percentage with final stage',
    },
    users: {
      viewProfile: 'View profile',
    },
    staff: {
      requires: 'Requires:',
    },
    exceptionsGroups: {
      select: 'Select exceptions',
    },
    lessons: {
      create: 'Create Lesson',
      new: 'Add new lesson',
      quantity: 'Lesson quantity',
    },
    modules: {
      create: 'Create Module',
      created: 'Module created',
      edit: 'Edit Module',
      new: 'New Module',
      'async-lesson-add': '+ Async lesson',
      'sync-lesson-add': '+ Sync lesson',
      'async-lessons': 'Async lessons',
      'sync-lesson': 'Sync lessons',
      'sync-lesson-placeholder': 'Input sync lesson name',
      'async-lesson-placeholder': 'Input async lesson name',
      plan: 'Module planning',
      'description-placeholder': 'Module description',
      'warning-courses-linked':
        'This version has active courses linked. Any change made to it does not impact active courses.',
    },
    periodicities: {
      onceaweek: 'Once a week',
      everytweeks1: 'Every two weeks starting first week',
      everytweeks2: 'Every two weeks starting second week',
      select: 'Select periodicity',
    },
    products: {
      errordata: 'Failed to get data, please try again.',
      cluster: 'Cluster',
      create: 'Create Product',
      edit: 'Edit Product',
      created: 'Product created',
      updated: 'Product updated',
      updatederror: 'An error ocurred while updating product',
      error: 'An error ocurred while creating product',
      code: 'Product code',
      select: 'Select Product',
      'select-cluster': 'Select Cluster',
      'select-duration': 'Select Duration',
      'select-course': 'Select Course',
      search: 'Search product',
      'list-title': 'Products',
      'career-list-title': 'Career Products',
      'course-list-title': 'Course Products',
      'on-demand-list-title': 'On Demand Products',
      'on-demand-b2b-list-title': 'On Demand B2B Products',
      duration: 'Duration',
      courses: 'Courses',
      course: 'Course',
      paths: {
        label: "Paths",
        placeholder: "Select paths",
      },
      path: 'Path',
      'path-placeholder': 'Select path',
      'slot-from': 'Slot from',
      'slot-to': 'Slot to',
      'admission-type': 'Admission type',
      'admission-type-placeholder': 'Select admission type',
      'admition-process-async': 'Async admission process',
      'admition-process-404': 'Admission process (404)',
      'admition-process-placeholder': 'Select admission process',
      'course-onboarding': 'Onboarding course on Playground',
      'course-onboarding-placeholder': 'Select onboarding course',
      'modal-enrollment': 'Run enrollment',
      'enrollment-successful': 'Successful Enrollment',
      'enrollment-timeout': 'Enrollment in process, check in a few minutes',
      'enrollment-fail-title': 'Enrollment was not completed',
      'enrollment-simulation-fail-default': 'Please try again later',
      'enrollment-simulation-fail-nousers': 'There arent users to enrollments in this product',
      'simulation-successful-title': 'Successful Simulation',
      'simulation-successful-content': 'The file has been downloaded',
      'simulation-fail-title': 'The simulation was not completed',
      'simulation-button': 'Run simulate (.csv)',
      'enrollment-button': 'Run enrollment',
      'enrollment-modal-question':
        'Are you sure you want to enroll for the product <strong>{{productCode}}</strong>? This action cannot be reversed.',
      language: 'Language',
      'language-placeholder': 'Select language',
      enrollments: 'Enrollments',
      enrollments_title: 'Product enrollments',
      enroll_users: 'Enroll student to Product',
      user_list: 'Select the user(s) to register the product',
      confirm_enroll: 'Enroll',
      enrollment_error: 'There was an error enrolling the user, check if the user already exists, or try again later',
      enrollment_requiered: 'You have to select at least one student',
      enrollment_success: 'Successfully Enrolled Students',
      enrollment_student_data: 'Student data',
      enrollment_product_data: 'Product data',
      enrollment_not_found: 'Can\'t find the user?',
      enrollment_create_option: '+ Create new user',
      'course-edit': 'Edit Course',
      'course-detail': 'Course Detail',
    },
    sessions: {
      'list-title': 'Session list',
      'show-async-class': 'Show asynchronous classes',
      open: 'Open lesson',
      'open-sucess': 'Lesson opened',
      'open-failed': 'Failed to open lesson',
      type: 'Type',
      state: 'State',
      programmed: 'Scheduled for',
      sync: 'Synchronous',
      async: 'Asynchronous',
      dictated: 'Dictated',
      released: 'Released',
      pending: 'Pending',
      'not-released': 'Not Released',
      'scheduled-range': '{{- start}} to {{- end}}',
    },
    students: {
      'list-title': 'Students',
      'import-title': 'Import from file',
      'finder-place-Holder': 'Search new student',
      'profile-title': 'Personal information',
      name: 'Name',
      'last-name': 'LastName',
      birthdate: 'Birth Date',
      'job-title': 'Job Title',
      'document-type': 'Identification Type',
      'document-number': 'Identification Number',
      'fiscal-id-type': 'Type of tax identification',
      'fiscal-id-number': 'Tax identification number',
      'fiscal-title': 'Tax data',
      'contact-title': 'Contact info',
      email: 'Email',
      'phone-code': 'Country code',
      phone: 'Phone number',
      country: 'Country',
      address: 'Address',
      studying: 'Studying',
      abandoned: 'Abandoned',
      approved: 'Approved',
      disapproved: 'Disapproved',
      recuperatory: 'Recuperatory',
      undefined: 'Undefined',
      assistance: 'attendance',
      product: {
        title: 'Product',
        select: 'Select product',
        code: 'Code',
        date: 'Registration made on',
        status_on_product: 'Student status in the product'
      },
      import: {
        select_title: "File selection",
        validate_title: "Data validation",
        import_data_title: "Import data",
        input_csv_label: "Download template file",
        select_file: "Select a CSV file",
        warning: {
          title: '¡Attention!',
          description: 'We have identified some data that may require your additional validation before importing. It is important that you review these details carefully to ensure that the information is accurate and complete. There may be discrepancies or missing data that could affect the integrity of the import. Please take a moment to verify and correct this data before proceeding with the import.',
          student: 'Student',
          track: 'Track',
          lastCourse: 'Current Commission',
          newCourse: 'New Commission',
          product: 'Product',
          warningCell: {
            already_enrolled_to_subject: "The user is already enrolled in the subject",
            already_in_file_user_subject: "There is already another enrollment of this user in this subject in the same csv",
            comm_enr_already_exists: "The course already exists",
            course_product_time_slot_mismatch: "The product's course time slots do not match",
            course_enrollments_already_exists: "The user is already enrolled in the course",
            course_enr_not_active: "The course is not active and will be reactivated",
            course_not_found: "The course does not exist",
            direct_enrollment_to_base_track: "The track is a base track and does not have automatic enrolment logic. It is recommended to enrol only in the product",
            existing_enrollment: "The user is repeating the course",
            more_than_one_prod_in_active_state: "More than one product in an active state was found",
            product_not_found: "The product does not exist",
            prod_enr_not_found: "The product course does not exist",
            product_enr_not_active: "The user's enrolment in the product is not active and will be reactivated, along with all its tracks and courses",
            track_not_found: "The track does not exist",
            track_not_in_product: "The track is not part of the product",
            track_enr_not_active: "The track is not active and will be reactivated, along with all its courses",
            user_not_found: "The user does not exist",
            track_enrollments_already_exists: "The user is already enrolled in the track",
            product_enrollments_already_exists: "The user is already enrolled in the product",
            user_not_active: "The user is not active",
            only_students_can_enroll_to_product: "Only users with the student role can enroll in products",
            host_will_enroll_on_track_courses: "You are going to enroll a host in a Track",
            incorrect_role_input: "Role not allowed",
            incorrect_enrollment_destination: "Nonexistent relationship between the specified course, track, and product",
          },
          enrollmentCell: {
            existing_enrollment: "Course change",
            enrollment_associate: "Association",
            enrollment: "Enrollment",
          },
        },
        complete: {
          title: 'All ready!',
          description: 'Your data has been sent for import. Our system is working on it and will handle the import processing efficiently. Please note that because the import is done asynchronously to ensure efficiency, it may take a while before you see the results.',
          import_other: 'Import another file',
          dashboard: 'Go to report'
        },
        success_validation: {
          title: 'Everything looks good!',
          description: '<paragraph>The validation of user data has been successfully completed. All data have been reviewed and confirmed without any problems. Now you are ready to carry out the importation.</paragraph>',
          cancel: 'Cancel',
          import_now: 'Import now',
          stats: {
            users: 'Users',
            enrollments: 'Enrollment',
            warnings: 'Warnings',
            errors: 'Errors'
          }
        },
        api_error: {
          title: 'Oops, we are having some difficulties...',
          description: 'Unfortunately, we had problems trying to load the data. Please try again. If the problem persists, please contact our support team.</paragraph>',
          import: 'Import another file'
        },
        error_validation: {
          title: 'Oops, something is not quite right with your file...',
          description: 'Unfortunately, we cannot process the file you tried to upload. It seems that there is a problem with the file extension or the data does not meet the necessary requirements for the importation of students.<paragraph>Make sure you are loading a file with the extension ".csv" and that the data is organized in columns separated by comas. Also, check that the columns in the file coincide with the fields required for import. If you have any doubts about the correct format, please review the template file or contact our support team for assistance.</paragraph>',
          import: 'Import another file',
          download: 'template file download'
        },
        progress_validation: {
          title: 'validating data',
          progress: '<span>{{quantity}}</span> of <span>{{total}}</span> records'
        },
        progress_import: {
          title: 'importing data'
        }
      }
    },
    shifts: {
      morning: 'Morning shift',
      evening: 'Late shift',
      night: 'Night shift',
      select: 'Select Shift',
    },
    allowed_students: {
      any: 'Open',
      scholarships: 'Closed',
      select: 'Select type',
    },
    stages: {
      modal_change_title: 'Product state change',
      modal_change_title_track: 'Track state change',
      button_change_stage: 'Change state',
      modal_confirmation_title: 'Confim product state change',
      modal_confirmation_question: '¿Are you sure you want to change the state of this career?',
      modal_confirmation_title_commission: 'Commission state change confirmation',
      modal_confirmation_question_commission:
        '¿Are you sure you want to change the state of this commission?',
      admission: 'Admission',
      studying: 'Studying',
      on_waiting_list: 'On waiting list',
      in_stand_by: 'Stand by',
      graduate: 'Graduated',
      abandoned: 'Abandoned',
      enrolled: 'Enrolled',
      recuperatory: 'Recuperatory',
      disapproved: 'Disapproved',
      approved: 'Approved',
      admitted: 'Admitted',
      in_stand_by_admitted: 'Admitted in stand by',
      abandoned_admission: 'Abandoned in admission',
      abandon_request: 'Abandon request',
      non_graduate: 'Non graduate',
      commission_change: 'Commission change',
      standalone_exam: 'Standalone Exam',
      non_attendance_studying: 'Non Attendance Studying',
      deadline_expired: 'Deadline Expired',

      'comments-about-change': 'Comments about the change',
      select_reason: 'Select reason',
      undefined: '-',

      '1': 'Admission',
      '2': 'Studying',
      '3': 'On waiting list',
      '4': 'Stand by',
      '5': 'Graduated',
      '6': 'Abandoned',
      '7': 'Enrolled',
      '8': 'Recuperatory',
      '9': 'Disapproved',
      '10': 'Approved',
      '11': 'Admitted',
      '12': 'Admitted in stand by',
      '13': 'Abandoned in admission',
      '14': 'Abandon request',
      '15': 'Non graduate',
      '16': 'Commission change',
      '17': 'Non Attendance Studying',
      '18': 'Standalone Exam',
      '19': 'Deadline Expired',

      edges: {
        abandoned_student: 'Abandoned student',
        abandoned_absent: 'Abandoned Absent',
        abandoned_administrative: 'Abandoned administrative',
        abandoned_expelled: 'Abandoned expelled',
        abandoned_change_course: 'Abandoned change course',
        abandoned_manual_admission_process: 'Abandoned manual admission process',
        abandoned_rejection: 'Abandoned rejection',
        abandoned_others: 'Abandoned student',
        abandoned_economic_difficulties: 'Abandoned due to economic difficulties',
        abandoned_sickness: 'Abandoned due to sickness',
        abandoned_admission_error: 'Abandoned due to error in admission',
        abandoned_time_management: 'Abandoned due to lack of time',
        abandoned_platform_discrepancy: 'Abandoned due to inconsistencies in platforms',
        abandoned_difficult_content: 'Abandoned due to difficult content',
        abandoned_easy_content: 'Abandoned due to easy content',
        abandoned_timeframe_changed_without_warn: 'Abandoned due to change of proposed time slot',
        abandoned_assignments_time_changed_littl:
          'Abandoned due to little anticipation of schedule changes per bimester',
        abandoned_scholarship_absent: 'Abandoned scholarship (Due to non-attendance)',
        abandoned_scholarship_bad_performance: 'Abandoned scholarship (For appealed subjects)',
        admission_manual_decision: 'Discharged due to admission error',
        abandoned_charge_error: 'Low due to loading error',
        abandoned_change_semester: 'Withdrawal due to change of semester',
        abandoned_personal_motives: 'Drop for personal reasons',
        abandoned_work_motives: 'Leave for work reasons',
        exam_absent: 'Absent to the exam',
        exam_failing_grade: 'Insufficient rating',
        abandoned_exam_retakes_limit_reached: 'Limit of appeal attempts',
        failing_attendance: 'Failing attendance',
        abandoned_course_modality: 'Abandoned due to course modality',
        abandoned_expectation_mismatch: 'Abandoned due to expectation mismatch',
        abandoned_achieved_objectives: 'Achieved learning objectives',
        abandoned_payment_default: 'Abandoned due to payment default',
        abandoned_pause_requested: 'Abandoned due to requested pause',
        abandoned_unknwon: 'Unknown',
      },
      'state-change-success': 'Stage updated successfully.',
      'no-stages-available': 'There are no more possible states for this commission.',
    },
    courses: {
      'list-title': 'Courses',
      select: 'Select course',
      create: 'Create course',
      created: 'Course created',
      'schedule-tooltip': 'Schedule',
      scheduled: 'Course scheduled',
      'scheduled-error': 'Something went wrong scheduling',
      edit: 'Edit Course',
      edited: 'Course edited',
      'detail-course': 'Detail',
      'career-courses': 'Career courses',
      'product-courses': 'Product courses',
      dayselector: {
        title: 'Days of study',
        button: 'Add days',
        modal: 'Add days of study',
      },
      detail: {
        'start-day': 'Starts on',
        'end-day': 'Ends on',
        'days-time': 'Days and times',
        calendarize: 'Schedule',
        recalendarize: 'Reschedule',
        'end-courses': 'End course',
        'close-courses': 'Close course',
      },
      enrollments: {
        list_title: 'Course enrollments',
      },
      modal_change_title: 'Course state change',
      studying: 'Studying',
      approved: 'Aprobada',
      'approved-plural': 'Approved',
      'disapproved-plural': 'Disapproved',
      disapproved: 'Desaprobada',
      'abandoned-plural': 'Abandoned',
      abandoned: 'Abandonada',
      versionwarning: 'Only those versions that are active are displayed.',
      code: 'Código Comisión',
      course_type: 'Course type',
      course_type_error: 'An error occurred while obtaining the list of course types.',
    },
    subjects: {
      'list-title': 'Subjects',
      create: 'Create Subject',
      created: 'Subject created',
      edit: 'Edit Subject',
      edited: 'Subject Updated',
      'description-placeholder': 'Subject description',
      plan: 'Class planning',
      'select-classification': 'Select clasification',
      'select-requirements': 'Select requirements',
      select: 'Select subject',
      sort: 'Save order',
      'sort-lessons-success': 'Lesson order saved successfully',
      'sort-modules-success': 'Module order saved successfully',
      'sort-lessons-error': 'Error while saving lesson order',
      'sort-modules-error': 'Error while saving module order',
      info: 'View subject information',
    },
    subjectVersions: {
      'list-title': 'Subject Versions',
      active: 'Active',
      inactive: 'Inactive',
      select: 'Select version',
      'disable-version-title': 'Disable version',
      'disable-version-error-title': 'Unable to disable this version',
      'disable-version-message':
        'This will prevent courses from being created with this version while it is inactive. Are you sure you want to disable this version?',
      'disable-version-error-message':
        'This subject version cannot be disabled because it has related courses in progress.',
      info: 'Version information',
      'edit-form-PG': 'Only visible and editable in Playground',
      edit: 'Edit subject version',
      create: 'Create subject version',
      'description-placeholder': 'Describe the subject version',
      'create-success-message': 'Subject version created successfully.',
      'create-error-message': 'Could not create Subject Version.',
      'edit-success-message': 'Subject version edited successfully.',
      'edit-error-message': 'Could not edit Matter Version.',
      language: 'Language',
      'language-placeholder': 'Select language',
      alias: 'Alias',
      'alias-hint': 'is the name that the version will have in Playground',
      'content': 'Content',
      'course-type': 'Course type',
      'course-type-placeholder': 'Select a type',
      'playground-course': 'Playground course',
      'playground-course-placeholder': 'Select a course'
    },
    timezone: {
      title: 'Time zone',
      select: 'Select time zone'
    },
    paths: {
      'title-create': 'Create Path',
      section: 'Section',
      new: 'Add path',
      'create-success': 'Path created',
      'create-error': 'Error while creating path',
    },
    interactions: {
      'interactions-registry': 'Interactions registry',
      'create-label': 'Create interaction',
      'new-label': 'New interaction',
      'write-here-label': 'Write details here',
      'error-msg-create-note': 'Note needs to be shorter than 4000 characters.',
      'success-msg-create-note': 'The interaction was created successfully!',
      'empty-list-msg': 'No interactions available at this moment.',
    },
    published: {
      dialog: {
        title: 'Publish product',
        message: '<block>You are about to publish the product <bold>{{code}}</bold>.</block><block>This action will cause the product to be displayed in the online sale.</block><break/><block>Are you sure to perform this action?</block>',
      },
    },
    unpublished: {
      dialog: {
        title: 'Unpublish product',
        message: '<block>You are about to unpublish the product <bold>{{code}}</bold>.</block><block>This action will stop the product from being displayed in the online sale.</block><break/><block>Are you sure to perform this action?</block>',
      },
    },
  },
  static: {
    tracks: 'Tracks',
    order: 'Order',
    enrollmentDate: 'Enrollment date',
    keepEnrollment: 'Keep course enrollment in Playground',
    isPlaygroundEnrollment: 'Enrolled in Playground',
    noPlaygroundEnrollment: 'Not Enrolled in Playground',
    products: 'Products',
    durationHours: "Duration (hours)",
    isFree: "Is free?",
    coverUrl: {
      label: 'Cover video URL',
      hint: 'Make sure the URL is a video',
    },
    modality: {
      label: "Modality",
      placeholder: "Choose a modality",
    },
    category: {
      label: "Category",
      placeholder: "Choose a category",
    },
    technology: {
      label: "Technology",
      placeholder: "Choose a technology",
    },
    level: {
      label: "Difficulty",
      placeholder: "Choose a difficulty",
    },
    theme: {
      label: 'Theme',
      placeholder: 'Choose a theme',
    },
    icon: {
      label: 'Icon',
      placeholder: 'Choose an icon',
    },
    businessUnits: {
      career: 'Career',
      course: 'Intensive course',
      in_company: 'In Company',
      inCompany: 'In Company',
      financial: 'Financial',
      on_demand: 'On Demand',
      onDemand: 'On Demand'
    },
    actual: 'actual',
    profile: 'Profile',
    'none-selected': 'None selected',
    'check-in': 'Start date',
    subjects: 'Subjects',
    state: 'State',
    actions: 'Actions',
    country: 'Country',
    type: 'Type',
    module: 'Module',
    code: 'Code',
    cancel: 'Cancel',
    confirm: 'Confirm',
    accept: 'Accept',
    open: 'Open',
    edit: 'Edit',
    action: 'Actions',
    classification: 'Clasification',
    exceptionsGroups: 'Holidays',
    dateFormat: 'MM-DD-YYYY',
    timeFormat: 'HH:mm',
    careers: 'Careers',
    change_state: 'Change state',
    import: 'Import from file',
    dateTimeFormat: 'MM-DD-YYYY HH:mm',
    doc: 'Identification',
    doc_type: 'Identification Type',
    date_time_utc: 'Day and time UTC',
    'days-title': 'Days',
    days: {
      0: 'Sunday',
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday',
      L: 'M',
      M: 'T',
      X: 'W',
      J: 'X',
      V: 'F',
      S: 'S',
      D: 'SU',
    },
    'days-of-study': 'Days of study',
    description: 'Description',
    'description-optional': 'Description (optional)',
    'description-mandatory': 'Description (mandatory)',
    duration: 'Duration',
    email: 'Email',
    date: 'Date',
    endDate: 'End date',
    endTime: 'End time',
    end_date: 'End date',
    id: 'Id',
    initial_date: 'Start date',
    inscription: 'Enrollment',
    'inscription-plural': 'Enrollments',
    interaction: 'Interaction',
    'interaction-plural': 'Interactions',
    job: 'Job',
    lesson: 'Lesson',
    lessons: 'Lessons',
    'lessons-list': 'Lessons list',
    'msg-error': 'Error',
    'msg-loading': 'Loading',
    'msg-required': 'Required',
    'msg-success': 'Success',
    'msg-warning': 'Warning',
    name: 'Name',
    name_of_course: "Course's name",
    periodicity: 'Periodicity',
    phone: 'Phone',
    requirements: 'Requirements',
    save: 'Save',
    shift: 'Shift',
    startDate: 'Start date',
    startTime: 'Start time',
    subject: 'Subject',
    subject_course: 'Course',
    course: 'Course',
    openDate: 'Opening date',
    surname: 'Surname',
    select: 'Select',
    vacancy: 'Vacancy',
    validators: {
      isNumber: 'Field must be a number',
      required: 'Field is required',
      urlRequired: 'Please enter a valid URL',
      min: 'Should be at least {{num}} characters',
      regex: '{{message}}',
      'version-mismatch': 'Format should be v.MMYYYY',
      itsBiggerThan: 'The field {{field1}} can not be bigger than {{field2}}',
      email: 'The field must be a valid email',
      maxCharsAndSpace: 'Must contain a maximum of 6 alphanumeric characters and no spaces',
      invalidSlug: 'The slug must contain only alphanumeric characters and hyphens',
    },
    version: 'Version',
    staff: {
      1: 'Student',
      2: 'Head',
      3: 'Assistant',
      4: 'Mentor',
      5: 'Host',
    },
    'staff-optional': 'Staff (optional)',
    sessions: 'Sessions',
    create: 'Create',
    nonrequired: 'Field not required',
    'save-changes': 'Save changes',
    'order-symbol': 'º',
    alias: 'Alias',
    aliasHint: 'It is the name that the course will have in the Playground for the student',
    catalogVisibility: {
      label: 'Show in explore',
      placeholder: 'Choose an option',
      options: {
        true: 'Yes',
        false: 'No',
      },
      hint: 'If you choose this option, the course will be visible in the explore section',
    },
    slug: 'Slug',
    slugDescription: 'Should contain no more than 100 characters',
    slugHint: 'It is the part of the URL that uniquely identifies this course. Should contain no more than 100 characters',
    keywords: 'Keywords',
    tags: 'Tags',
    tagsHint: 'Use ENTER to add a new item',
    bu: 'bu',
    cluster: 'Cluster',
    occupancy: 'Occupancy',
    active: 'Active',
    'active-plural': 'Active',
    'inactive-plural': 'Inactive',
    cohort: 'Cohort',
    'select-state': 'Select state',
    'select-stage': 'Select stage',
    'select-change-state-reason': 'Select change reason',
    businessUnit: 'Business Unit',
    'select-businessUnit': 'Select Business Unit',
    'course-type': 'Course Type',
    'select-course-type': 'Select Course Type',
    'full-name': 'Fullname',
    'students-label': 'Students',
    'staff-label': 'Staff',
    'staff-students-label': 'Staff and students',
    'error-msg-generic': 'An error ocurred. Please try again later.',
    loading: 'Loading',
    'time-zone': 'Time zone',
    apply: 'Apply',
    exist: 'exists',
    published: 'Published',
    yes: 'Yes',
    no: 'No',
    filters: 'Filters',
    track_stages: 'Track stages',
    productStage: 'Product stage',
    enroll: 'Enroll',
    allowed_students: 'Type',
    showing: 'Showing <strong>{{start}}</strong> to <strong>{{end}}</strong> of <strong>{{total}}</strong> results',
    next: 'Next',
    previous: 'Previous',
    product_type: 'Product type',
    courses: 'Courses',
    coursesWithoutProduct: 'These courses are not associated with any specific product.',
    tracksWithoutProduct: 'These tracks are not associated with any specific product.',
    role: 'Role',
  },
  errors: {
    'email-in-use': 'This account is already linked to another user',
    'wrong-identification-number': 'You must enter a valid number',
  },
  language: {
    spanish: 'Spanish',
    portuguese: 'Portuguese',
    english: 'English',
  },
};
